import { Regions } from './PageMetaTagsTypes';

export const REGIONS: Regions = {
  'en-apac': [
    'en-apac',
    'en-bd',
    'en-kz',
    'en-bn',
    'en-la',
    'en-lk',
    'en-kh',
    'en-my',
    'en-tw',
    'en-mm',
    'en-th',
    'en-id',
    'en-pk',
    'en-vn',
    'en-ph',
  ],
  'en-emea': [
    'en-emea',
    'en-gr',
    'en-mt',
    'en-sk',
    'en-ma',
    'en-is',
    'en-ee',
    'en-lv',
    'en-pt',
    'en-ua',
    'en-lt',
    'en-lu',
  ],
  'en-mea': [
    'en-mea',
    'en-bh',
    'en-eg',
    'en-ir',
    'en-il',
    'en-ke',
    'en-lb',
    'en-sa',
    'en-ae',
    'en-zw',
    'en-ng',
    'en-na',
    'en-mz',
    'en-mu',
    'en-gh',
  ],
  'fr-mea': ['fr-mea', 'fr-ma', 'fr-tn', 'fr-dz'],
  'es-lat': ['es-lat', 'es-mx', 'es-co', 'es-ar', 'es-pe', 'es-pa', 'es-cl', 'es-cr'],
};

export const ISO_ENGLISH = 'en';
export const LINK_REL_ALTERNATE = 'alternate';
